import React from 'react'
import './styles.scss'

function LoginCommonFrame(props) {
  return (
    <div className="login-common-frame">
      <header>
        <div className="header-content">
          <img src="//www.simboss.com/images/logo.png" alt=""/>
        </div>
      </header>
      <div className="content">
        <div className="title">
          {props.title}
        </div>
        <div className="content-form">
          <img src='https://simboss-public.oss-cn-hangzhou.aliyuncs.com/pentagon/img/platform/platform-device-left-img.png' alt='' />
          <div className="form">
            {props.children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoginCommonFrame
